module.exports = __webpack_public_path__ + "static/media/050-floss.0f68612b.svg";